<script setup>
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFunctionGetter, useMapGetter } from 'dashboard/composables/store';
import { usePolicy } from 'dashboard/composables/usePolicy';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const route = useRoute();
const router = useRouter();
const team = useFunctionGetter('teams/getTeamById', route.params.id);
const ledTeams = useMapGetter('teams/getLedTeams');

const { checkPermissions } = usePolicy();
const hasFullReports = computed(() =>
  checkPermissions(['administrator', 'report_manage'])
);
const getterKey = computed(() =>
  hasFullReports.value ? 'teams/getTeams' : 'teams/getLedTeams'
);

// When the user only has report_team_manage, prevent access to reports of
// teams they don't lead by redirecting to the overview.
const isForbiddenForLeader = computed(() => {
  if (hasFullReports.value) return false;
  if (!team.value?.id) return false;
  const teamId = Number(route.params.id);
  return !ledTeams.value.some(t => t.id === teamId);
});

watch(
  isForbiddenForLeader,
  forbidden => {
    if (forbidden) router.replace({ name: 'team_reports_index' });
  },
  { immediate: true }
);
</script>

<template>
  <WootReports
    v-if="team.id && !isForbiddenForLeader"
    :key="team.id"
    type="team"
    :getter-key="getterKey"
    action-key="teams/get"
    :selected-item="team"
    :download-button-label="$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')"
    :report-title="$t('TEAM_REPORTS.HEADER')"
    has-back-button
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
